import { createClient, createFetchClient } from "@punto/api-client";
import { type paths } from "@punto/api-client/schema-portus";

import { config } from "@/lib/config";

const wrappedFetch: typeof fetch = (...args) => {
  return fetch(...args);
};

const fetchClient = createFetchClient<paths>({
  baseUrl: config.API_URL,
  fetch: wrappedFetch,
});

const $api = createClient(fetchClient);

export { fetchClient, $api };
